export default "__VITE_PUBLIC_ASSET__5acd30c8__"